import { types } from "../types/types";

export const typingSet = (payload) => ({
    type: types.typingSet,
    payload,
});

export const typingClear = (payload) => ({
    type: types.typingClear,
    payload,
});

export const typingPrune = () => ({
    type: types.typingPrune,
});
